// Qué deja filtrar cada columna de la pestaña «Back orders». Mismo patrón que
// `filtrosDeColumna.ts` (cargas): la clave es la columna y el valor, sus
// secciones. El cliente no es una columna —es la banda que agrupa—, así que va
// como pestaña de la cabecera «Pedido», que es la que pinta el primer dato de
// cada grupo.
//
// El pendiente no lleva filtro: es un número, y el modelo de filtro de columna
// sólo sabe de listas y rangos de fecha.
import type { TFunction } from 'i18next'

import type { OpcionMulti } from '@/components/common/MultiFiltro'
import type { EstadoBackOrder } from '@/types'
import { tieneAlgoQueOfrecer, type FiltroColumna } from '@/utils/filtroColumna'
import type { FiltrosBackOrders } from '@/utils/fichaCarga'

export interface CatalogosBackOrders {
  cliente: OpcionMulti[]
  pedido: OpcionMulti[]
  articulo: OpcionMulti[]
  carga: OpcionMulti[]
  estado: OpcionMulti[]
}

export function filtrosBackOrders(
  f: FiltrosBackOrders,
  onChange: (patch: Partial<FiltrosBackOrders>) => void,
  cat: CatalogosBackOrders,
  t: TFunction,
): Record<string, FiltroColumna> {
  const crudo: Record<string, FiltroColumna> = {
    pedido: [
      {
        tipo: 'lista',
        nombre: t('cargasSalida.backOrders.columnas.pedido'),
        opciones: cat.pedido,
        seleccion: f.pedido,
        onSeleccion: pedido => onChange({ pedido }),
        titulosMono: true,
        permitirLibre: true,
      },
      {
        tipo: 'lista',
        nombre: t('cargasSalida.filtros.cliente'),
        opciones: cat.cliente,
        seleccion: f.cliente,
        onSeleccion: cliente => onChange({ cliente }),
      },
    ],
    articulo: [{
      tipo: 'lista',
      opciones: cat.articulo,
      seleccion: f.articulo,
      onSeleccion: articulo => onChange({ articulo }),
      titulosMono: true,
      permitirLibre: true,
    }],
    carga: [{
      tipo: 'lista',
      opciones: cat.carga,
      seleccion: f.carga,
      onSeleccion: carga => onChange({ carga }),
      titulosMono: true,
      permitirLibre: true,
    }],
    antiguedad: [{
      tipo: 'rango',
      nombre: t('cargasSalida.backOrders.fechaBo'),
      desde: f.desde,
      hasta: f.hasta,
      onDesde: desde => onChange({ desde }),
      onHasta: hasta => onChange({ hasta }),
    }],
    estado: [{
      tipo: 'lista',
      opciones: cat.estado,
      seleccion: f.estado,
      onSeleccion: v => onChange({ estado: v as EstadoBackOrder[] }),
    }],
  }

  const limpio: Record<string, FiltroColumna> = {}
  for (const [clave, secciones] of Object.entries(crudo)) {
    const utiles = secciones.filter(tieneAlgoQueOfrecer)
    if (utiles.length > 0) limpio[clave] = utiles
  }
  return limpio
}
